module.exports = __webpack_public_path__ + "img/search-user.6a9c0753.svg";